export default "__VITE_ASSET__Bvywio7o__"